import Alpine from 'alpinejs'

window.Alpine = Alpine

// Handle Turbo navigation - reinitialize Alpine on each page load
document.addEventListener('turbo:load', () => {
  // Alpine 3.x auto-initializes new elements, but we ensure it's ready
  if (!Alpine.isReady) {
    Alpine.start()
  }
})

document.addEventListener('turbo:before-render', () => {
  // Clean up Alpine before Turbo replaces the DOM
  Alpine.destroyTree(document.body)
})

// Start Alpine for initial page load
Alpine.start()
